import storage from '@/utils/storage';
import snd_ping from '@/assets/sound/ping.mp3'
import snd_fail from '@/assets/sound/fail.mp3'
import snd_drop from '@/assets/sound/drop.mp3'
import snd_sms from '@/assets/sound/sms.mp3'
import snd_email from '@/assets/sound/email.mp3'

const state = {
  initiated: false,
  mute: false,
  sounds: {
    ok: snd_ping,
    time: snd_drop,
    not: snd_fail,
    sms: snd_sms,
    mail: snd_email,
  }
}

const actions = {
  audio_initiate ({commit}) {
    commit('audio_initiate');
  },
  toggle_mute ({commit}) {
    commit('toogle_mute');
  },
  playSound ({commit}, snd) {
    commit('playSound', snd);
  }
}

const mutations = {
  audio_initiate (state) {
    state.initiated = true;
  },
  toggle_mute (state) {
    state.mute = !state.mute;
    storage.save('sound_mute', state.mute);
  },
  playSound (state, sound) {
    if(state.initiated && !state.mute && state.sounds[sound]) {
      var audio = new Audio(state.sounds[sound]);
      audio.play();
    }
  }
}

const getters = {
  getmuted: (state) => {
    state.mute = storage.load('sound_mute') || false;
    return state.mute;
  }
}

export default {
  state,
  actions,
  mutations,
  getters
}
